<template>
  <section class="coupon-detail">
    <div class="abs-top-right">
      <v-button @click="() => $router.back()">Back</v-button>
    </div>
    <h2>{{ isEdit ? 'Edit' : 'New' }} SME Coupon</h2>

    <el-form
      ref="form"
      :rules="rules"
      :model="formData">
      <div class="form-box">
        <div
          v-if="isEdit"
          class="form-item width-400">
          <span>Coupon ID</span>
          <span>{{couponId}}</span>
        </div>
        <h3>Metadata</h3>
        <div class="form-container">
          <div class="form-item width-400">
            <span>Coupon Code</span>
            <el-form-item prop="coupon_code">
              <v-input
                v-model="formData.coupon_code"
                maxlength="25"
                :disabled="isEdit"/>
            </el-form-item>
          </div>
          <div class="flex-sb">
            <div class="form-half form-item">
              <span>English</span>
              <el-form-item prop="title_en">
                <v-input
                  v-model="formData.title_en"
                  maxlength="40"
                />
              </el-form-item>
            </div>
            <div class="form-half form-item">
              <span>Chinese (Traditional)</span>
              <el-form-item prop="title_hk">
                <v-input
                  v-model="formData.title_hk"
                  maxlength="15"
                />
              </el-form-item>
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-half form-item">
              <span>Description</span>
              <el-form-item prop="description_en">
                <v-input
                  v-model="formData.description_en"
                  maxlength="300"

                  type="textarea"/>
              </el-form-item>
            </div>
            <div class="form-half form-item">
              <span>Description</span>
              <el-form-item prop="description_hk">
                <v-input
                  v-model="formData.description_hk"
                  maxlength="100"
                  type="textarea"/>
              </el-form-item>
            </div>
          </div>
        </div>
      </div>
      <div class="form-box  ">
        <div class=" form-container width-400">
          <h3>Applies To</h3>
          <div class="form-item">
            <el-form-item prop="applies_to_type">
              <el-radio
                v-model="formData.applies_to_type"
                :disabled="isEdit"
                label="4">All SME Categories
              </el-radio>
            </el-form-item>
          </div>
          <div class="form-item">
            <el-form-item prop="applies_to_type">
              <el-radio
                v-model="formData.applies_to_type"
                :disabled="isEdit"
                label="5">Specific SME Category
              </el-radio>
            </el-form-item>
          </div>
          <div
            v-if="formData.applies_to_type=='5'"
            class="sub-form-item form-item width-400">
            <el-form-item prop="insurance_type">
              <v-select
                v-model="formData.insurance_type"
                :disabled="isEdit"
                :group="true"
                :list="typeOptions"></v-select>
            </el-form-item>
          </div>
          <!--          <div-->
          <!--            v-if="formData.applies_to_type=='3'"-->
          <!--            class="sub-form-item width-400">-->
          <!--            <div class="form-item">-->
          <!--              <el-form-item prop="company_id">-->
          <!--                <v-select-->
          <!--                  v-model="formData.company_id"-->
          <!--                  :list="insurerOptions"-->
          <!--                  :disabled="isEdit"/>-->
          <!--              </el-form-item>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
      </div>
      <div class="form-box">
        <h3>Activity</h3>
        <div class="form-container">
          <div class="form-item width-400">
            <span>Time Period</span>
            <el-form-item prop="coupon_date">
              <v-date-picker
                v-model="formData.coupon_date"
                :format="'dd-MM-yyyy HH:mm:ss'"
                :valueFormat="'yyyy-MM-dd HH:mm:ss'"
                :default-time="['00:00:00', '23:59:59']"
                type="datetimerange"/>
            </el-form-item>
          </div>
          <v-checkbox
            v-model="formData.status"
            value="1"
            :isBoolean="false">Activated
          </v-checkbox>
        </div>
      </div>
      <div class="coupon-right">
        <v-button @click="() => $router.back()">Cancel</v-button>
        <v-button
          type="success"
          @click="handlerSave">Save
        </v-button>
      </div>
    </el-form>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {addSMECoupon, couponOption, editCoupon, getCouponDetail} from '@/api/coupon'

export default {
  name: 'SmeCouponDetail',
  mixins: [MixinOptions, MixinRules],
  data() {
    const checkMinimuSelect = (rule, value, callback) => {
      const { minimum_price_select } = this.formData
      if( value<0&&minimum_price_select == 1 ) {
        callback(new Error( this.$t('placeholder.input')))
      }
      callback()
    }
    const checkLimitSaveTimes = (rule, value, callback) => {
      const { limited_save_select } = this.formData
      if( !value&&limited_save_select == 1 ) {
        callback(new Error( this.$t('placeholder.input')))
      }
      callback()
    }
    const checkInsurerType = (rule, value, callback) => {
      const { applies_to_type ,limit_insurance_type_select} = this.formData
      if( !value&&applies_to_type == 2||!value&&applies_to_type==3&&limit_insurance_type_select==1 ) {
        callback(new Error( this.$t('placeholder.select')))
      }
      callback()
    }
    const checkCompanyId = (rule, value, callback) => {
      const { applies_to_type } = this.formData
      if( !value&&applies_to_type==3 ) {
        callback(new Error( this.$t('placeholder.select')))
      }
      callback()
    }
    const checkAmount = (rule, value, callback) => {
      const { amount_type } = this.formData
      if(value<0&&(amount_type ==1 ||amount_type==2) ) {
        callback(new Error(this.$t('placeholder.input')))
      }
      callback()
    }
    const checkFixMax = (rule, value, callback) => {
      const { amount_type,fixed_maximum_select } = this.formData
      if(!value&&amount_type ==1&&fixed_maximum_select==1 ) {
        callback(new Error(this.$t('placeholder.input')))
      }
      callback()
    }
    const checkTiers = (rule, value, callback) => {
      const { amount_type } = this.formData
      if(!value&&amount_type ==3 ) {
        callback(new Error(this.$t('placeholder.input')))
      }
      callback()
    }
    return {
      formData: {
        coupon_code: '',//must
        title_en: '',
        title_hk: '',
        description_en: '',
        description_hk: '',

        applies_to_type: '4',//i


        is_new_customer: '',//i

        status: 2,
        coupon_date: '',
        insurance_type:'',
      },

      couponOptionList:[],
      rules: {
        minimum_price: [
          { validator: checkMinimuSelect, trigger: ['blur'],},
          {  pattern: /^[0-9]*[0-9][0-9]*$/, message: '只能輸入正整數' },
        ],
        limited_save_times:[
          { validator: checkLimitSaveTimes, trigger: ['blur'] },
          {  pattern: /^[0-9]*[1-9][0-9]*$/, message: '只能輸入正整數' },
        ],
        insurance_type:[
          { validator: checkInsurerType, trigger: ['blur'] },
        ],
        company_id: [
          { validator: checkCompanyId, trigger: ['blur'] }
        ],
        amount_percent:[
          { validator: checkAmount, trigger: ['blur'] },
          // {  pattern: /^[0-9]*[1-9][0-9]*$/, message: '只能輸入正整數' },
          {  pattern: /^(?:[1-9]?\d|100)$/, message: '只能輸入0-100' },
        ],
        fixed_amount:[
          { validator: checkAmount, trigger: ['blur'] },
          {  pattern: /^[0-9]*[0-9][0-9]*$/, message: '只能輸入正整數' },
        ],
        fixed_maximum:[
          { validator: checkFixMax, trigger: ['blur'] },
          {  pattern: /^[0-9]*[1-9][0-9]*$/, message: '只能輸入正整數' },
        ],
        limit_amount:[
          { validator: checkTiers, trigger: ['blur'] },
        ],
        discount_amount:[
          { validator: checkTiers, trigger: ['blur'] },
        ],
      },
    }
  },
  computed: {
    isEdit() {
      return this.$route.query.code ? true : false
    },
    couponId(){
      return this.$route.query.cid
    },
    purchaseType() {
      return [
        {
          id: 10,
          name: 'New Policy',
        },
        {
          id: 20,
          name: 'Renewal',
        },
      ]
    },
    typeOptions() {
      return [
        {
          label: 'By Insurance Type',
          options: this.globalOptions.manual_quote_type
        },
        {
          label: 'By Industry',
          options: this.globalOptions.manual_quote_industry_type
        }
      ]
    },
  },
  watch: {
    '$route.query.code': {
      immediate: true,
      handler(val) {
        if (val) {
          this.network().getCouponDetail(val)
        }
      }
    },
    'formData.fixed_maximum_select':{
      immediate: true,
      handler(val) {
        if (!val) {
          this.$nextTick(()=>{
            this.$refs.form.clearValidate('fixed_maximum')
          })
        }
      }
    },
    'formData.coupon_code':{
      immediate: true,
      handler(val) {
        if (val) {
          this.formData.coupon_code = this.formData.coupon_code.toLocaleUpperCase()
        }
      }
    }
  },
  created() {
    // this.network().couponOption()
  },
  methods: {
    handlerChangeRaido(name) {
      this[name] = this[name] == '1' ? '0' : '1'
    },
    handlerAddTiers(){
      let data = {
        limit_amount:'',
        discount_amount:''
      }
      data = JSON.parse(JSON.stringify(data))
      this.formData.tiers.push(data)
    },
    handlerDelTiers(index){
      this.formData.tiers.splice(index,1)
    },
    handlerSave() {
      this.$refs.form.validate((valid,rules) => {
        if(valid){
          let {status = 2} = this.formData
          this.formData.status = status?status:2
          let params = {
            ...this.formData,
            end_time: this.formData.coupon_date ? this.formData.coupon_date[1] : '',
            start_time: this.formData.coupon_date ? this.formData.coupon_date[0] : '',
            // product_id: this.formData.insurance_type?this.formData.insurance_type[0]:'',
            // class_id:  this.formData.insurance_type?this.formData.insurance_type[1]:'',
          }
          if (this.isEdit)
            this.network().editCoupon(params)
          else
            this.network().addSMECoupon(params)
        }else{
          this.scrollToValidDom(rules)
        }
      })
    },
    network() {
      return {
        editCoupon: async (params = {}) => {
          let {coupon_code, end_time, start_time, status} = params
          const {data} = await editCoupon(params)
          this.$message({
            type: 'success',
            message: data.message_language
          })
          this.$router.back()
        },
        addSMECoupon: async params => {
          const {data} = await addSMECoupon(params)
          this.$message({
            type: 'success',
            message: data.message_language
          })
          this.$router.back()
        },
        couponOption: async params => {
          const {data} = await couponOption(params)
          this.couponOptionList = data.insurance
        },
        getCouponDetail: async params => {
          const {data} = await getCouponDetail({coupon_code: params})
          Object.keys(this.formData).some(key => {
            if (key in data) {
              this.formData[key] = data[key]
            }
          })
          let {insurance_type,description, code, title, start_time, end_time,applies_to_type} = data
          this.formData.description_en = description['en-US']
          this.formData.description_hk = description['zh-HK']
          this.formData.title_en = title['en-US']
          this.formData.title_hk = title['zh-HK']
          this.formData.coupon_code = code,
          this.formData.coupon_date = [start_time, end_time]
          this.formData.applies_to_type = applies_to_type.toString()
          // this.formData.insurance_type = insurance_type
        }
      }
    }
  },
}
</script>
<style lang="scss" scoped>
  .coupon-detail {
    position: relative;
    color: #24292e;

    h2 {
      font-size: 20px;
    }

    h3 {
      font-size: 16px;
      color: #24292E;
    }

    .width-400 {
      width: 370px;
    }
    .button-width{
      width: 348px;
    }
    .class-flex{
      align-items: center;
      span{
        margin: 0 10px;
      }
      .red-icon{
        color: #CB2431;
        margin-left: 10px;
      }
    }
    .form-box {
      padding-bottom: 20px;
      border-bottom: 1px solid #e1e4e8;
      padding-top: 31.5px;
    }

    .sub-form-item {
      margin-left: 20px;
    }

    .form-container {
      width: 70%;
      max-width: 800px;

      .flex-center {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .el-input, .el-select {
          margin-left: 10px;
          width: 200px;
        }
      }
    }

    .form-item {
      ::v-deep .el-checkbox {
        display: flex;
        //align-items: center;
      }
    }

    .coupon-right {
      display: flex;
      justify-content: flex-end;
      margin-top: 32px;
    }

    .margin-top-24 {
      margin-top: 24px;
    }
    ::v-deep .el-cascader{
      width: 100%;
      .el-input__inner{
        height: 32px;
        line-height: 32px;
      }
    }
  }
</style>
